import { convertToMinutes } from '@salecycle/ui-component-library';
import { drawerInitialState } from '../tabs/CampaignWorkflowTab/state/Drawer/drawerInitialState';
import { CampaignEditorState } from './CampaignEditorState';
import { OnsiteCampaignStatus } from 'sections/onsite-campaigns/types';

export const campaignEditorInitialState: CampaignEditorState = {
  ...drawerInitialState,
  name: '',
  status: OnsiteCampaignStatus.DRAFT,
  allowList: [],
  emailAllowList: [],
  lookBackPeriodInMinutes: convertToMinutes(24, 'hours'),
  branches: {},
  trigger: {
    exitIntentAreas: [],
    inactivity: null,
    onPageLoad: false,
    selectedTriggers: [],
    segmentation: undefined,
    frequency: '',
  },
  areBranchesLoadedFromServer: false,
  messages: {},
  splitTests: {},
  scheduling: {},
};
